import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import categories from './navigation';

function Drawer(props) {
  const router = useRouter();

  return (
    <div id="menu_drawer" className="flex flex-col items-center text-white">
      {categories.map((category) => {
        return category.submenu.length > 0 ? (
          <Disclosure key={category.key}>
            {({ open }) => (
              <>
                <Disclosure.Button className="label">
                  <span
                    className={`flex items-center ${
                      open ? 'text-white opacity-100' : 'text-white opacity-60'
                    }`}
                  >
                    {category.label}
                    {open ? (
                      <ChevronUpIcon
                        className="ml-2 -mr-1 h-8 w-8"
                        aria-hidden="true"
                      />
                    ) : (
                      <ChevronDownIcon
                        className="ml-2 -mr-1 h-8 w-8"
                        aria-hidden="true"
                      />
                    )}
                  </span>
                </Disclosure.Button>

                {category.submenu.map((sub) => {
                  return (
                    <Disclosure.Panel className="sub_label" key={sub.key}>
                      <Link href={sub.url}>
                        <a
                          className={`flex items-center ${
                            router.pathname == sub.url
                              ? 'text-white opacity-100'
                              : 'text-white opacity-60'
                          }`}
                          onClick={props.closeDrawer}
                        >
                          {sub.icon}
                          {sub.label}
                        </a>
                      </Link>
                    </Disclosure.Panel>
                  );
                })}
              </>
            )}
          </Disclosure>
        ) : (
          <Disclosure key={category.key}>
            <Disclosure.Button className="label">
              <Link href={category.url}>
                <a
                  className={
                    router.pathname == category.url
                      ? 'text-white opacity-100'
                      : 'text-white opacity-60'
                  }
                  onClick={props.closeDrawer}
                >
                  {category.label}
                </a>
              </Link>
            </Disclosure.Button>
          </Disclosure>
        );
      })}
    </div>
  );
}

export default Drawer;
